import Comms from "components/Comms";
import { useState } from "react";
import styled from "styled-components";

interface MainLayoutProps {
  heading?: string;
  children?: any;
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 16px [comms-start] 90px [comms-end subwrapper-start] 1fr [subwrapper-end];
  height: calc(100vh - 60px);
  overflow: hidden;
`;

const SubWrapper = styled.div`
  overflow-y: scroll;
  grid-column: subwrapper;
  display: grid;
  grid-template-columns: 1fr [content-start] max(800px) [content-end] 1fr;
`;

const ContentWrapper = styled.div`
  grid-column: content;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
`;

const Heading = styled.h1`
  align-self: flex-start;
  margin-bottom: 20px;
`;

const MainLayout = ({ heading, children }: MainLayoutProps) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <Wrapper>
      <Comms
        isChatOpen={isChatOpen}
        setIsChatOpen={setIsChatOpen}
        styles={
          isChatOpen
            ? { gridColumn: "1 / -1", margin: "0 16px" }
            : { gridColumn: "comms" }
        }
      />
      {!isChatOpen && (
        <SubWrapper>
          <ContentWrapper>
            {heading ? <Heading>{heading}</Heading> : null}
            {children}
          </ContentWrapper>
        </SubWrapper>
      )}
    </Wrapper>
  );
};

export default MainLayout;
